module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-input', {
    attrs: {
      "placeholder": "请输入姓名",
      "icon": "search"
    },
    model: {
      value: (_vm.search_text),
      callback: function($$v) {
        _vm.search_text = $$v
      },
      expression: "search_text"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chooselist"
  }, _vm._l((_vm.user_list), function(item, index) {
    return _c('span', {
      key: item.id
    }, [_vm._v(_vm._s(item.real_name)), _c('i', {
      staticClass: "el-icon-circle-cross",
      on: {
        "click": function($event) {
          _vm.removeUser(index)
        }
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_vm._m(0), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "list-wrap"
  }, _vm._l((_vm.user_options), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.chooseUser(item)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(item.user_name))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.real_name
      }
    }, [_vm._v(_vm._s(item.real_name))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.position_name
      }
    }, [_vm._v(_vm._s(_vm._f("placeholder")(item.position_name)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("justDate")(item.work_date)))])])
  }))], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('div', [_vm._v("工号")]), _vm._v(" "), _c('div', [_vm._v("姓名")]), _vm._v(" "), _c('div', [_vm._v("岗位属性")]), _vm._v(" "), _c('div', [_vm._v("入职时间")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-52b68960!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/person/add-member.vue
// module id = 745
// module chunks = 1